<template>
  <div class="flex title-container" :class="spacing">
    <span class="title" :style="`color:${color}`" :class="[size]">
      {{ title }}
    </span>
    <tooltip v-if="tooltip" :title="tooltip" :fillColor="color" />
  </div>
</template>
<script>
import Tooltip from "../TooltipInfo.vue";
export default {
  name: "card",
  components: {
    Tooltip,
  },
  props: {
    title: {
      type: String,
      description: "title",
    },
    tooltip: {
      type: String,
      description: "tooltip string",
    },
    color: {
      type: String,
    },
    size: {
      type: String,
    },
    spacing: {
      type: String,
    },
  },
};
</script>
<style lang="scss" scoped>
.flex {
  width: 100%;
  align-items: center;
  justify-content: space-between;
  margin-bottom: toRem(8);
  color: $headingsColor;
  flex-shrink: 0;
  .title {
    font-weight: 500;
    margin-right: 3px;
    white-space: nowrap;
    &.s {
      font-size: $s-font;
    }
    &.m {
      font-size: $m-font;
    }
    &.l {
      font-size: $l-font;
    }
  }
  &.left {
    justify-content: left;
  }
}
</style>